import styled, { css } from 'styled-components';

export const IconButtonContainer = styled.button<{ $disableHover: boolean }>`
  ${({ theme, $disableHover }) => css`
    background-color: transparent;
    color: ${theme.splitcPalette.neutral[5]};
    height: fit-content;

    border: none;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    font-weight: 500;
    padding: ${theme.splitcPadding.container.extra_small};

    ${
      !$disableHover &&
      css`
        &:hover:not(:disabled) {
          transition: all 250ms ease-in-out;
          opacity: 0.7;
          background-color: ${theme.splitcPalette.neutral[9]};
        }
      `
    }

    &:active:not(:disabled) {
      transition: all 250ms ease-in-out;
      opacity: 0.4;
    }

    &:disabled {
      cursor: not-allowed;
      filter: opacity(0.25);
    }
  `}
`;
